import { Box, SxProps, Theme } from "@mui/material";
import { useState } from "react";

import { ToolbarLayerProvider } from "./ToolbarLayerProvider";

interface ToolbarColumnProps {
    children: React.ReactNode;
    sx?: SxProps<Theme>;
}

/**
 * Wraps a vertical stack of toolbars with shared hover and flyout coordination.
 * All child toolbars show tooltips when the column is hovered and suppress
 * them while any flyout is open.
 */
export function ToolbarColumn({ children, sx }: ToolbarColumnProps) {
    const [areaHovered, setAreaHovered] = useState(false);

    return (
        <ToolbarLayerProvider areaHovered={areaHovered}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    pointerEvents: "auto",
                    ...sx,
                }}
                onMouseEnter={() => setAreaHovered(true)}
                onMouseLeave={() => setAreaHovered(false)}
            >
                {children}
            </Box>
        </ToolbarLayerProvider>
    );
}
